/*
 * Copyright © 2017, Rezo Zero
 *
 * This file is part of Suprême NTM.
 *
 * Suprême NTM can not be copied and/or distributed without
 * the express permission of Rezo Zero.
 *
 * @file RushBlock.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 * @copyright Rezo Zero 2018
 */

import {AbstractBlock} from 'starting-blocks'
import TweenMax from 'TweenMax'

export default class RushBlock extends AbstractBlock {
    init () {
        super.init()

        /**
         * @type {number}
         */
        this.random = Math.floor(Math.random() * 30) + 15

        /**
         * @type {number}
         */
        this.maxScrollTop = document.body.scrollHeight - window.innerHeight

        // Binded methods
        this.onScroll = this.onScroll.bind(this)
    }

    initEvents () {
        super.initEvents()
        window.addEventListener('scroll', this.onScroll)
    }

    destroyEvents () {
        super.destroyEvents()
        window.removeEventListener('scroll', this.onScroll)
    }

    onScroll () {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop
        const percent = (scrollTop / this.maxScrollTop) * this.random

        TweenMax.to(this.$cont, 2.5, {
            xPercent: -percent
        })
    }

    onLoad () {
        super.onLoad()
    }

    onResize () {
        super.onResize()
        this.maxScrollTop = document.body.scrollHeight - window.innerHeight
    }

    onPageReady () {
        super.onPageReady()
    }
}



// WEBPACK FOOTER //
// ./webpack/js/blocks/RushBlock.js